import React, { FC, ReactElement, useEffect, useState } from 'react'
import { UsersByExtension as UsersByExtensionLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import Modal from '../../Common/Components/Modal'
import { StandardContexts } from '../../Common/Components/StandardContexts'
import { ModalContextProvider } from '../../Common/Contexts/ModalContext'
import { ReactState } from '../../Common/Types/Types'
import { UsersByExtension } from '../Main/UsersByExtension'
import { clearModalHelpTopic, setModalHelpTopicID } from '../../Common/Utils/HelpPortal'
import { DocTopic } from '../../Common/Constants/Documentation'
import { $window } from '../../../NonReact/common/AkixiWindow'

export const UsersByExtensionsModal: FC = (): ReactElement => {
    // Access language resources directly without context as this is top level component.
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(UsersByExtensionLanguage.NAME)

    // Whether the modal window is open.
    const [isModalOpen, setModalOpen]: ReactState<boolean> = useState<boolean>(true)

    const [modalTitle, setModalTitle]: ReactState<string> = useState<string>(
        language.get(UsersByExtensionLanguage.UsersByExtensions_ModalTitle)
    )

    const closeModal = (): void => {
        $window.disableHotKeys = false
        // Component is controlled externally.
        setModalOpen(false)
        clearModalHelpTopic()
    }

    useEffect(() => {
        setModalHelpTopicID(DocTopic.MANAGE_ENTERPRISE_USERS)
    }, [])

    return (
        <ModalContextProvider
            modalInput={{
                closeModal,
                setModalTitle
            }}
        >
            <StandardContexts>
                <Modal
                    isOpen={isModalOpen}
                    closeOnBackdropClick={false}
                    isClosableWithXButton={true}
                    onClose={closeModal}
                >
                    <div className='modal-title-report-config'>{modalTitle}</div>
                    <div className='users-by-extensions'>
                        <UsersByExtension />
                    </div>
                </Modal>
            </StandardContexts>
        </ModalContextProvider>
    )
}
